<script>
    import { selectedItem } from '../../../store/store.js';
    import { displayInt } from '../../../utils/utils.js';
</script>

<div class="key-value-table box">
    <h5>Uppvärmning och energianvändning</h5>
    <table>
        <colgroup>
            <col style="width: 65%;">
            <col style="width: 30%;">
            <col style="width: 5%;">
        </colgroup>
        <tbody>
            <tr class="row100 body">
                <td class="column1">
                    <h6>Uppvärmningssystem</h6>
                </td>
                <td class="column2">
                <h6>{ $selectedItem.heating_system }</h6>
                </td>
                <td class="column3">
                </td>
            </tr>
            <tr class="row100 body">
                <td class="column1">
                    <h6>Total energikonsumtion</h6>
                </td>
                <td class="column2">
                <h6>{ displayInt($selectedItem.total_energy_consumption) }  kWh/år</h6>
                </td>
                <td class="column3">
                </td>
            </tr>
            <tr class="row100 body">
                <td class="column1">
                    <h6>Total elkonsumtion</h6>
                </td>
                <td class="column2">
                <h6>{ displayInt($selectedItem.total_electricity_consumption) } kWh/år</h6>
                </td>
                <td class="column3">
                </td>
            </tr>
            <tr class="row100 body">
                <td class="column1">
                    <h6>Fastighetsel</h6>
                </td>
                <td class="column2">
                <h6>{ displayInt($selectedItem.fastighetsel) } kWh/år</h6>
                </td>
                <td class="column3">
                </td>
            </tr>
            <tr class="row100 body">
                <td class="column1">
                    <h6>Energikonsumtion för varmvattenberedare</h6>
                </td>
                <td class="column2">
                <h6>{ displayInt($selectedItem.energy_consumption_for_hot_water_preparation) } kWh/år</h6>
                </td>
                <td class="column3">
                </td>
            </tr>
            <tr class="row100 body">
                <td class="column1">
                    <h6>Fjärrvärmeförbrukning</h6>
                </td>
                <td class="column2">
                <h6>{ displayInt($selectedItem.district_heating_consumption) } kWh/år</h6>
                </td>
                <td class="column3">
                </td>
            </tr>
            <tr class="row100 body">
                <td class="column1">
                    <h6>Energiprestanda</h6>
                </td>
                <td class="column2">
                <h6>{ displayInt($selectedItem.energiprestanda) } kWh/m²</h6>
                </td>
                <td class="column3">
                </td>
            </tr>
            <tr class="row100 body">
                <td class="column1">
                    <h6>Referens för liknande hus</h6>
                </td>
                <td class="column2">
                <h6>{ displayInt($selectedItem.reference_for_similar_houses) } kWh/m²</h6>
                </td>
                <td class="column3">
                </td>
            </tr>
        </tbody>
    </table>
</div>